import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

/**
 * Represents live messaging
 */
export const MessagingClockIcon: FunctionComponent<MessagingClockIconProps> = ({
  height = 24,
  width = 24,
  fillColor,
  testID,
}) => {
  const { colors } = useTheme()

  return (
    <Svg width={width} height={height} viewBox='0 0 24 24' fill='none' testID={testID}>
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.22472 3.7207C1.99604 3.7207 1 4.71674 1 5.94542V14.8443C1 16.073 1.99604 17.069 3.22472 17.069H4.36053L6.61008 19.7685C6.75098 19.9376 6.95969 20.0353 7.17978 20.0353C7.39986 20.0353 7.60857 19.9376 7.74947 19.7685L9.99902 17.069H11.8764C12.286 17.069 12.618 16.737 12.618 16.3274C12.618 15.9179 12.286 15.5859 11.8764 15.5859H9.65169C9.4316 15.5859 9.22289 15.6836 9.08199 15.8527L7.17978 18.1354L5.27756 15.8527C5.13666 15.6836 4.92795 15.5859 4.70787 15.5859H3.22472C2.81516 15.5859 2.48315 15.2539 2.48315 14.8443V5.94542C2.48315 5.53586 2.81516 5.20385 3.22472 5.20385H17.0674C17.477 5.20385 17.809 5.53586 17.809 5.94542V9.15891C17.809 9.56846 18.141 9.90048 18.5506 9.90048C18.9601 9.90048 19.2921 9.56847 19.2921 9.15891V5.94542C19.2921 4.71674 18.2961 3.7207 17.0674 3.7207H3.22472ZM5.48476 8.17014H14.8074C15.0134 8.17014 15.211 8.24827 15.3567 8.38734C15.5024 8.52641 15.5843 8.71503 15.5843 8.91171C15.5843 9.10839 15.5024 9.29701 15.3567 9.43608C15.211 9.57515 15.0134 9.65328 14.8074 9.65328H5.48476C5.27871 9.65328 5.08111 9.57515 4.93542 9.43608C4.78972 9.29701 4.70787 9.10839 4.70787 8.91171C4.70787 8.71503 4.78972 8.52641 4.93542 8.38734C5.08111 8.24827 5.27871 8.17014 5.48476 8.17014ZM23 15.8331C23 18.2904 21.0079 20.2825 18.5506 20.2825C16.0932 20.2825 14.1011 18.2904 14.1011 15.8331C14.1011 13.3757 16.0932 11.3836 18.5506 11.3836C21.0079 11.3836 23 13.3757 23 15.8331ZM18.5506 13.3555C18.8267 13.3555 19.0506 13.5794 19.0506 13.8555V15.8274H20.5281C20.8042 15.8274 21.0281 16.0513 21.0281 16.3274C21.0281 16.6036 20.8042 16.8274 20.5281 16.8274H18.5506C18.2744 16.8274 18.0506 16.6036 18.0506 16.3274V13.8555C18.0506 13.5794 18.2744 13.3555 18.5506 13.3555ZM11.827 11.1364H5.49888C5.28909 11.1364 5.0879 11.2146 4.93955 11.3536C4.79121 11.4927 4.70787 11.6813 4.70787 11.878C4.70787 12.0747 4.79121 12.2633 4.93955 12.4024C5.0879 12.5415 5.28909 12.6196 5.49888 12.6196H11.827C12.0368 12.6196 12.238 12.5415 12.3863 12.4024C12.5346 12.2633 12.618 12.0747 12.618 11.878C12.618 11.6813 12.5346 11.4927 12.3863 11.3536C12.238 11.2146 12.0368 11.1364 11.827 11.1364Z'
        fill={fillColor || colors.iconInactive}
      />
    </Svg>
  )
}

type MessagingClockIconProps = {
  height?: string | number
  width?: string | number
  fillColor?: string
  testID?: string
}
